import styled from "styled-components";
import CustomLabel from "./CustomLabel";
import { BiSad } from "react-icons/bi";
import LoggedInBoilerplate from "../pages/loggedIn/LoggedInBoilerplate";
import CornerProfileButton from "../pages/loggedIn/CornerProfileButton";

const Container = styled.div`
  background-color: var(--surface2);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 100px;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.div`
  font-size: 70px;
  opacity: 0.6;
  color: var(--accent);
`;

const Container1 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 100px;
`;

export default function PermissionDeniedPage() {
  return (
    <Container1>
      <Container>
        <Icon>
          <BiSad />
        </Icon>

        <CustomLabel>
          Votre rôle ne vous permet pas d'accéder à cette page
        </CustomLabel>
      </Container>

      <CornerProfileButton />
    </Container1>
  );

  //   <LoggedInBoilerplate
  //   titleLine1={"Désolée"}
  //   titleLine2={"Tu n'as pas la permission"}
  // >
  // </LoggedInBoilerplate>
}
